import React, { useEffect } from "react"
import { useAppCtx } from "lib/state"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { appTools, cn } from "lib/utils"
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function TitleBlockRender({ config, className="" }: { config?:any; className?:string }){

  const { useTailwind }:any = useTemplatePreviewCtx()
  const styling = useRenderStyling("w-96 h-14 bg-neutral-200 border border-solid border-neutral-700 rounded-md flex justify-center items-center text-2xl font-semibold uppercase", "styleObj")

  return (
    <div id="mm-titleblock" {...styling}>
      { config?.title || "Dispute Evidence" }
    </div>
  )
}